import React from 'react';
import { Accordion, AccordionToggle, Card, AccordionCollapse, Table } from "react-bootstrap";
import Player from "./Player";

export default function Info() {  

  return (
    <div>
        <Accordion >
            <Card  style={{ borderColor:"#2c2c32",marginInline:"1%", backgroundColor: "#2c2c32"}}>
                <AccordionToggle as={Card.Header} eventKey="cbd" style={{alignSelf:"center"}}>  
                    <div style={{ backgroundColor: "rgb(194, 194, 194)", borderRadius: "5px", paddingInline: "10px", cursor: "pointer", width: "fit-content"}} >
                        <text style={{color: "#2c2c32"}} > 
                            Qual è il massimo livello di CBD?
                        </text>
                    </div>
                </AccordionToggle>
                <AccordionCollapse eventKey="cbd" style={{backgroundColor: "rgb(194, 194, 194)"}}>
                    <Card.Body style={{textAlign: "justify", marginInline: "5%"}}>
                        <text>
                            <strong>Quanto CBD può avere un'erba?</strong>
                            <br/>
                            Come spieghiamo in questo video la percentuale di CBD non può superare il 15/16%. 
                            <br/><br/>
                                <div style={{width: "70%"}}>
                                    <Player videoId="u5aAoEjnZ5Q"/>
                                </div>
                            <br/>
                            <strong>Perchè?</strong>
                            <br/>
                            La cannabis riesce a sintetizzare i due cannabinoidi principali (THC e CBD) con un rapporto di 1:30; questo vuol dire che se un'erba avesse l'1% di THC potrebbe arrivare ad avere al massimo il 30% di CBD, e viceversa. Dato che in Italia la percentuale di THC consentita è max 0.5%, va da sè che il CBD massimo in un'erba non alterata non può andare oltre questa percentuale.
                            <br/><br/>
                            <strong>Cosa significa se trovo un'erba con CBD superiore?</strong>
                            <br/>
                            Se i valori sforano questo limite ci sono due possibilità: 
                            <li>è stato aggiunto del CBD alle cime (raro),</li> 
                            <li>i valori sono falsi*.</li>
                            <br/>
                            *spesso sulle confezioni troviamo scritto il valore preceduto dal segno minore: es. CBD	&#60;20 %, 
                            <br/>
                            l'utilizzo del segno minore è un escamotage per non dover scrivere il falso e trarre in inganno i disattenti. 
                        </text>
                    </Card.Body>
                </AccordionCollapse>
            </Card>
            <Card style={{ borderColor:"#2c2c32", marginInline:"1%", backgroundColor: "#2c2c32"}}>
                <AccordionToggle as={Card.Header} eventKey="terpenati" style={{alignSelf:"center"}} > 
                    <div style={{ backgroundColor: "rgb(194, 194, 194)", borderRadius: "5px", paddingInline: "10px", cursor: "pointer", width: "fit-content"}} >
                        <text style={{color: "#2c2c32"}} > 
                            Cosa sono i prodotti terpenati?
                        </text>
                    </div>
                </AccordionToggle>
                    <AccordionCollapse eventKey="terpenati" style={{backgroundColor: "rgb(194, 194, 194)"}}>
                    <Card.Body style={{textAlign: "justify", marginInline: "5%"}}>
                        <text style={{wordBreak: "break-all"}}>
                            <strong>Cosa sono i prodotti terpenati?</strong>
                            <br/><br/>
                            Nell'irregolamentato mercato della cannabis legale italiana spesso <strong>non abbiamo la certezza</strong> di cosa stiamo comprando, soprattutto quando si parla di estrazioni. 
                            La cannabis per rimanere "legale" in Italia deve avere un contenuto di <strong>THC non superiore allo 0.5%</strong>, per questo la produzione di estratti è un processo delicato. 
                            <br/><br/>
                            Le estrazioni concentrano tutto il buono che la pianta ha da offrirci (cannabinoidi, terpeni, ecc.) e pertanto possono facilmente <strong>sforare il limite</strong>.
                            <br/><br/>
                            Per poter commercializzare prodotti che sforano i produttori hanno <strong>due scelte</strong>:
                            <li><strong>allungarli</strong> con scarti della pianta (es. pasta cruda),</li>
                            <li><strong>sottoporli a processi</strong> che denaturano il THC in CBN (es. sottoporli a calore).</li> 
                            <br/>
                            Questi processi possono deteriorare il profilo terpenico, perciò vengono aggiunte <strong>soluzioni terpeniche</strong> secondariamente per donare al prodotto finale odore e sapore più intensi.
                            <br/>
                            Un prodotto terpenato non per forza è malsano o di pessima qualità ma è giusto sapere che si tratta di <strong>prodotti costruiti</strong>.
                            <br/><br/>
                            Diversi produttori stanno abbandonando questa tipologia di prodotti spostandosi su estrazioni solventless su piante <strong>CBG</strong>.
                            A differenza delle genetiche CBD, le genetiche CBG possono avere valori altissimi di CBG mantenendo valori di THC <strong>prossimi allo zero</strong>. Questo le rende perfette per essere sottoposte ad estrazioni non necessitando di elaborazioni aggiuntive.  
                            </text>
                    </Card.Body>
                </AccordionCollapse>
            </Card>
            <Card style={{ borderColor:"#2c2c32", marginInline:"1%", backgroundColor: "#2c2c32"}}>
                <AccordionToggle as={Card.Header} eventKey="rosin" style={{alignSelf:"center"}}> 
                    <div style={{ backgroundColor: "rgb(194, 194, 194)", borderRadius: "5px", paddingInline: "10px", cursor: "pointer", width: "fit-content"}} >
                        <text style={{color: "#2c2c32"}} > 
                            Guida al ROSIN
                        </text>
                    </div>
                </AccordionToggle>
                    <AccordionCollapse eventKey="rosin" style={{backgroundColor: "rgb(194, 194, 194)"}}>
                    <Card.Body style={{textAlign: "justify", marginInline: "5%"}}>
                        
                        <div style={{width: "70%"}}>
                            <Player videoId="s-AtxAIedqw"/>
                        </div>
                        <text style={{textAlign: "left"}}>
                           Nel video utilizziamo la <a href="https://www.lisotech.eu/it/home/54-lisotech-2-ton-press.html" target="_blank">pressa da 2 Ton</a> fornita da Lisotech.eu.    
                        </text>
                        <br/><br/>
                        <text style={{textAlign: "left"}}>
                            Guida gentilmente offerta da <a href="https://www.lisotech.eu/it/blog" target="_blank">Lisotech.eu</a>    
                        </text>
                        <br/>
                        <br/>
                        <strong>Perché Scegliere Il Rosin?</strong>
                        <br/>
                        <br/>
                        <strong>PULITO</strong>
                        <br/>
                        <text style={{textAlign: "left"}}>
                            Non c'è bisogno di utilizzare solventi, di conseguenza il prodotto finale sarà completamente naturale e privo di sostanze nocive come butano o etanolo.
                        </text>
                        <br/>
                        <br/>
                        <strong>SEMPLICE</strong>
                        <br/>
                        <text style={{textAlign: "left"}}> 
                            Non viene richiesta una particolare esperienza per ottenere buoni risultati grazie alla facilità di esecuzione del processo.
                            Non occorre utilizzare prodotti aggiuntivi e ulteriori lavorazioni.
                        </text>
                        <br/>
                        <br/>
                        <strong>VELOCE</strong>
                        <br/>
                        <text style={{textAlign: "left"}}>
                            A confronto degli altri processi di estrazione che richiedono lunghi tempi di lavorazione, a volte ore o persino giorni, il ciclo di spremitura tramite rosinpress necessita solo di qualche minuto sia per le grandi che per le piccole quantità.
                        </text>
                        <br/>
                        <hr/>
                        <strong>Come Funziona?</strong>
                        <br/>
                        <text style={{textAlign: "left"}}>
                            Il processo consiste nel separare la resina dalle infiorescenze o dal polline sfruttando la pressione ed il calore.
                        </text>
                        <br/>
                        <br/>
                        <strong>I Tre Fattori Da Tener Sempre Presenti Sono:</strong>
                        <br/>
                        <Table striped bordered hover variant="dark">
                            <thead>
                                <tr>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Temperatura</th>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Tempo</th>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Pressione</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>
                                        Facilita il distaccamento dei cristalli.
                                    </td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>
                                        Preserva l'integrità dei cannabinoidi e dei terpeni.
                                    </td >
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>
                                        Facilita la fuoriuscita della resina dal materiale lavorato.
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                        <br/>
                        <strong>Linea Guida:</strong>
                        <br/>
                        <Table striped bordered hover variant="dark">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Temperatura C°</th>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Tempo secondi"</th>
                                    <th style={{fontSize:"75%", wordWrap: "anywhere"}}>Pressione PSI</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>infiorescenze</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>85° - 110°</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>15" - 90"</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>1200psi - 2500psi</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>Polline</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>70° - 100°</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>20" - 60"</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>700psi - 2000psi</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>Altro (proveniente da altre lavorazioni)</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>55° - 85°</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>20" - 60"</td>
                                    <td style={{fontSize:"75%", wordWrap: "anywhere"}}>300psi - 1500psi</td>
                                </tr>
                            </tbody>
                        </Table>
                        <br/>
                        <text style={{textAlign: "left"}}>
                                Questa tabella è la base di partenza per ottenere i primi risultati ma non fornisce in modo esaustivo abbastanza dati per realizzare un prodotto di ottima qualità.
                                I vari parametri vanno applicati in modo differente in base al prodotto da lavorare.
                            <br/>
                            <br/>
                                Se la pressione non è abbastanza alta, solitamente viene compensata da un aumento di temperatura e vice versa, quando avremo a disposizione molta pressione saremo in grado di abbassare la temperatura, in questo modo riusciremo a preservare meglio la qualità del rosin prodotto.
                            <br/>
                            <br/>
                                Generalmente utilizzando temperature più basse aumentano i tempi di processo, questo è dovuto al fatto che le gocce di rosin presenti nelle infiorescenze o nel polline tendono a rimanere integre a temperature minori a discapito della fluidità, questo causa difficoltà nello “scivolare” all'esterno.
                            <br/>
                            <br/>
                                Per risolvere questo problema ed equilibrare la spremitura è necessario aumentare la forza premente.
                            <br/>
                            <br/>
                                La pressione va applicata sempre in modo graduale permettendo così alla materia prima di creare il giusto flusso di espulsione dei suoi componenti resinosi e in modo da dare tempo ai filtri e alla carta di disporsi nel modo giusto senza strapparsi.
                            <br/>
                            <br/>
                                Il miglior modo per creare il giusto flusso affinché il rosin esca velocemente dalla zona calda delle piastre è quello di piegare la carta protettiva a metà, ripiegare i lati che si posizioneranno dalla parte più corta delle piastre ed inserirvi all'interno il materiale da spremere.
                            <br/>
                            <br/>
                                Noi consigliamo di utilizzare sempre la nostra carta testata per garantirvi i migliori risultati.
                            <br/>
                            <br/>
                                Le nostre rosinpress sono progettate in modo da poter applicare e monitorare correttamente tutti i parametri in modo ottimale ma siamo consapevoli che i migliori risultati vengono ottenuti sempre dalle materie prime utilizzate nei processi di estrazione.
                                Il colore del rosin può variare in base a diversi fattori. 
                            <br/>
                            <br/>
                                Quando vengono lavorati prodotti freschi il colore tenderà ad essere più chiaro, questa variabile può dipendere anche dal ceppo (strain) di provenienza della pianta. Il colore non è indice di purezza o di qualità.
                                In base alla materia prima da lavorare cambia leggermente il processo.
                        </text>
                        <br/>
                        <hr/>
                        <strong>FIORE</strong>
                        <br/>
                        <text style={{textAlign: "left"}}>
                        I   l metodo migliore per lavorare le infiorescenze è quello di non utilizzare dei filtri o di utilizzare filtri con caratteristiche dimensionali superiori ai 160 micron, questo perché solitamente le infiorescenze rimangono compatte e non tendono a fuoriuscire dalle piastre.
                        <br/>
                            Quando le quantità aumentano e inizia a diventare difficile il mantenimento delle infiorescenze tra le piastre è consigliato contenerle preventivamente nei filtri o pre-compressarle mediante l'utilizzo di pre-presse che consentono di compattare i fiori diminuendone il volume e rendendoli più semplici da gestire. In questo caso i filtri avranno solo funzione di contenimento e non di filtraggio.
                        <br/>
                            Se il rosin ottenuto contiene delle impurità è necessario ripulirlo inserendolo all'interno di filtri di dimensioni da 10 a 37 micron e ripetere la spremitura diminuendo la pressione e il calore (70°). 
                        </text>
                        <br/>
                        <br/>
                        <strong>POLLINE</strong>
                        <br/>
                        <text>
                            Per ottenere degli ottimi risultati partendo da dei setacciati è necessario utilizzare dei filtri da 10 a 90 micron. Il sacchetto (rosin bag) contenente il polline va posto preventivamente a contatto delle piastre e va atteso che si scaldi prima di essere pressato per migliorarne la fuoriuscita.
                            <br/>
                            La pressione da applicare è inferiore rispetto alle infiorescenze e va applicata più lentamente per evitare rotture dei filtri e della carta antiaderente.
                        </text>
                        <br/>
                        <br/>
                        <strong>RACCOLTA ROSIN</strong>
                        <br/>
                        <text>
                            Come risultato del processo otterremo la carta antiaderente con attaccato il nostro prezioso rosin che può risultare più o meno appiccicoso. Utilizzando una piccola spatola andremo a grattare via il rosin e a raccoglierlo.
                        <br/>
                            Nel caso non si riesca a separare il rosin dalla carta perché troppo liquido basterà appoggiare la carta su di una superficie fredda e attendere che si addensi il rosin. Nel caso contrario il rosin sarà di una consistenza polverosa e difficile da raccogliere, procediamo in senso inverso ponendo la carta su una superficie calda e attendiamo che il rosin torni ad una consistenza più liquida.
                        <br/>
                            La pressione da applicare è inferiore rispetto alle infiorescenze e va applicata più lentamente per evitare rotture dei filtri e della carta antiaderente.
                        </text>
                    </Card.Body>
                </AccordionCollapse>
            </Card>
        </Accordion>
    </div>
    );
}